import React from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const getDescendantProp = (obj, path, splitter = '.') => {
  let temp = obj;
  path.split(splitter).forEach(tk => {
    temp = temp && temp[tk];
  });
  return temp;
};
